import { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Visibility from "@material-ui/icons/Visibility";
import { useAttendanceLocalMapStyles } from "./styles";
import { Cancellation } from "../../../../../../../@types/cancellation";

type Props = {
  cancellation: Cancellation
};

export default function CancellationReason({ cancellation }: Props) {
  const [open, setOpen] = useState(false);
  const { classes } = useAttendanceLocalMapStyles();

  return (
    <>
      <Button
        startIcon={<Visibility fontSize="small" />}
        className={classes.button}
        onClick={() => setOpen(true)}
      >
        Visualizar Texto
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
        <Card>
          <CardHeader
            avatar={<Visibility />}
            title={<Typography variant="h5">Motivo</Typography>}
            className={classes.cardHeader}
          />
          <CardContent className={classes.cardContent}>
            <Typography variant="subtitle1">{cancellation?.texto}</Typography>
          </CardContent>
          <CardActions className={classes.cardActions}>
            <Button
              className={classes.button}
              onClick={() => setOpen(false)}
            >
              Fechar
            </Button>
          </CardActions>
        </Card>
      </Dialog>
    </>
  );
}
